import createLocationModel from '../lib/create_location_model';

export default createLocationModel({
  modelName: 'WebhooksAdmin',
  properties: {},

  statics: {
    breadcrumb: 'Webhooks Admin',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/integrations/webhooks_admin.js